import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { Show } from '../models/show.model';
import { map, concatMap } from 'rxjs/operators';

class ApiShow {
   public acf: Object;
}

@Injectable({
  providedIn: 'root'
})
export class ShowService {
  /* the REST API of WP limits to 100 posts per page, but the default is 10 */
  private API_URL = 'http://espaciofm.com.ar/blog/wp-json/acf/v3/shows?per_page=100';
  constructor(private httpService: HttpClient) { }

  public getAllShows(): Observable<Show[]> {
     return this.httpService.get<ApiShow[]>(this.API_URL).pipe(
        map(shows => shows.map(show => new Show().deserialize(show.acf)))
     );
  }

  /**
   * Returns an observable which emits the current show every 30 seconds.
   */
  public getCurrentShow(): Observable<Show> {
     const show$ = this.httpService.get<ApiShow[]>(this.API_URL);
     const trigger$ = timer(0, 30000);
     return trigger$.pipe(
        concatMap(_ => show$),
        map(shows => {
           const _shows = shows.map(show => new Show().deserialize(show.acf));
           return _shows.find(show => show.broadcastsNow());
        })
     );
  }
}
